import { Card, CircularProgress, Typography, Button } from "@mui/material";
import { CustomButton } from "../components/CustomButton";
import { useState } from "react";
import { styles } from "../theme/styles";
import { Creators } from "../store/ducks/users";
import { connect } from "react-redux";
import { Creators as CreatorsConfig } from "../store/ducks/config";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef } from "react";
import ExcelEditor from "./ExcelEditor";
import Swal from "sweetalert2";
import axios from "axios";

const PassForm = () => {
  const { idOrder } = useParams();
  const navigate = useNavigate();
  const excelRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(new Date());
  const [materialesOrden, setMaterialesOrden] = useState(null); //materialesorden
  const [erroresTabla, setErroresTabla] = useState({});
  const formattedDate = date.toLocaleDateString("es-ES", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  //console.log("MATERIALES ORDEN", materialesOrden);

  const getOrdenInfo = async (numeroOrden) => {
    if (!numeroOrden) return;
    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_PETCOZOO}/reporteRecepcion/getInfoOrderMongo`,
        { idOrder: numeroOrden },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: `${process.env.REACT_APP_APIKEY}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.data.data && response.data.data.jsonInformacion.length > 0) {
        setMaterialesOrden(response.data.data.jsonInformacion);
      }
    } catch (error) {
      console.error("Error al obtener info de la orden:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (idOrder) {
      getOrdenInfo(idOrder);
    }
  }, []);

  const handleAddRow = () => {
    excelRef.current?.addRow();
  };

  const validateTable = (rows) => {
    const erroresPorCelda = {};
    let hayErrores = false;

    rows.forEach((row, rowIndex) => {
      const isManual = row.manual === true;
      const obligatorios = isManual
        ? ["materialId", "piezasPedidas", "costoUnitario"]
        : ["facturados"];
      obligatorios.forEach((campo) => {
        if (!row[campo] || row[campo].toString().trim() === "") {
          hayErrores = true;
          erroresPorCelda[`${rowIndex}-${campo}`] = true;
        }
      });

      // Si seleccionan no aptos
      if (
        row.noAptos &&
        row.noAptos.toString().trim() !== "" &&
        row.noAptos.toString().trim() !== "0"
      ) {
        [
          "problemasEnRecepcion",
          "diagnostico",
          "tratamiento",
          "comentariosGenerales",
        ].forEach((campo) => {
          if (!row[campo] || row[campo].toString().trim() === "") {
            hayErrores = true;
            erroresPorCelda[`${rowIndex}-${campo}`] = true;
          }
        });
      }
    });

    if (hayErrores) {
      Swal.fire({
        icon: "warning",
        title: "Campos vacíos",
        text: "Por favor, llena todos los campos antes de continuar",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
        width: 500,
      });
      return erroresPorCelda;
    }
    return null;
  };

  const handleSaveData = async (e) => {
    if (!materialesOrden || !materialesOrden.length === 0) {
      return;
    }
    const errores = validateTable(materialesOrden);
    if (errores) {
      setErroresTabla(errores);
      return;
    }
    setErroresTabla({});
    try {
      setLoading(true);
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_PETCOZOO}/reporteRecepcion/updateInfoOrder/1`,
        {
          idOrder: idOrder,
          jsonInformacion: materialesOrden,
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: `${process.env.REACT_APP_APIKEY}`,
            "Content-Type": "application/json",
          },
        },
      );
      setLoading(false);
      navigate(`/reporterecepcionEvidencias/${idOrder}`);
    } catch (error) {
      console.log("error guardando info de tabla: ", error);
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Fallo al guardar la información. Intente de nuevo",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
      });
    }
  };

  return (
    <div className="div-reporte-table">
      <Typography
        variant="h6"
        justifyContent="center"
        color="#00205b"
        style={styles.titleaux}>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-around",
          }}>
          <span
            style={{
              fontWeight: "normal",
              fontSize: "80%",
              color: "black",
              fontWeight: "bold",
            }}>
            {" "}
            {formattedDate}
          </span>
          &nbsp;&nbsp; REPORTE DE RECEPCIÓN&nbsp;&nbsp;{" "}
          <span
            style={{
              fontWeight: "normal",
              fontSize: "80%",
              color: "black",
              fontWeight: "bold",
            }}>
            ORDEN &nbsp;
            {idOrder}
          </span>
        </div>
      </Typography>
      <div className="container-reporte">
        <svg
          style={{
            cursor: "pointer",
          }}
          onClick={(e) => {
            e.preventDefault();
            navigate(`/reporterecepcionForm/${idOrder}`);
          }}
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#00205b"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round">
          <path d="M5 12l14 0" />
          <path d="M5 12l6 6" />
          <path d="M5 12l6 -6" />
        </svg>
        <p className="card-repo">
          <span style={{ color: "#C53030" }}>
            ⚠️ <strong>RECUERDA:</strong>{" "}
          </span>
          <span> El </span>
          <strong>reporte de recepción</strong> deberá generarse{" "}
          <strong style={{ color: "#004AAD" }}>de forma inmediata</strong> al
          momento de recibir el pedido.
          <br />
          <br />
          Posteriormente, será necesario{" "}
          <strong>dar seguimiento al mismo reporte</strong> dentro de un periodo
          máximo de <strong style={{ color: "#D97706" }}>24 horas</strong> para{" "}
          <strong>alimento vivo y congelado</strong>, y de{" "}
          <strong style={{ color: "#D97706" }}>48 horas</strong> para{" "}
          <strong>peces y animales</strong>, registrando las observaciones o
          actualizaciones correspondientes.
        </p>

        {materialesOrden && materialesOrden.length > 0 && (
          <ExcelEditor
            ref={excelRef}
            materialesOrden={materialesOrden}
            setMaterialesOrden={setMaterialesOrden}
            idOrder={idOrder}
            errores={erroresTabla}
            setErrores={setErroresTabla}
          />
        )}

        <div className="div-2-btn ">
          <CustomButton
            variant="contained"
            style={{
              backgroundColor: "#FFC107",
              color: "#000",
              width: "180px",
            }}
            onClick={handleAddRow}>
            Agregar fila
          </CustomButton>
          {!loading ? (
            <CustomButton
              variant="contained"
              onClick={handleSaveData}
              style={{
                width: "180px",
              }}
              type="submit">
              SIGUIENTE
            </CustomButton>
          ) : (
            <CircularProgress />
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    menu: state.users.menu,
    userData: state.users.data,
    idNumber: state.users.idNumber,
    token: state.users.uid,
    loading: state.users.loading,
    message: state.config.message,
  };
};

const creators = {
  logout: Creators.logout,
  changePassword: Creators.changePassword,
  clearMessage: CreatorsConfig.clearMessage,
};

export default connect(mapStateToProps, creators)(PassForm);
